import { Injectable } from '@angular/core';
import { ServiceStock } from './service-stock.service';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserPreferenceService {
  retValue: number = 0;

  constructor(private services: ServiceStock) { }

  public saveUserPreference() {
    this.buildIwsPreferredList();

    let inputMap = new Map();
    inputMap.set('Body.userName', this.services.UserPreference.userName);
    inputMap.set('Body.language', this.services.UserPreference.language);
    inputMap.set('Body.themeName', this.services.UserPreference.themeName);
    inputMap.set('Body.tickerSpeed', this.services.UserPreference.tickerSpeed);
    inputMap.set('Body.selectedStock', JSON.stringify(this.services.UserPreference.selectedStock));  // ticker Stock
    inputMap.set('Body.marketWatchColumn', this.services.UserPreference.marketWatchColumn);
    inputMap.set('Body.marketMatrixDepthDetails', this.services.UserPreference.marketMatrixDepthDetails);
    inputMap.set('Body.userPreference', JSON.stringify(this.services.UserPreference.userPreference));

    this.services.http.fetchApi('/preference/user/save', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          let resObj = res['response'][0];
          // ...
          this.retValue = respCode;
        }
      },
      async (httpError) => {
        var err = httpError['error']
        // if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        // }
        this.retValue = -1;
      }
    );
  }

  public getIwsTheme(): string {
    let themeName: string;
    let themes = this.services.dataStore.getThemes();
    themes.forEach(element => {
      if (element.id == this.services.UserPreference.themeName)
        themeName = element.text.toLowerCase();
    });
    return themeName;
  }

  public getIwsLang(): string {
    let langName: string;
    if (this.services.UserPreference.language.length == 2) {
      langName = this.services.UserPreference.language.charAt(0).toUpperCase()
        + this.services.UserPreference.language.charAt(1); // en > En, bn > Bn // ref. main-header.component.html
    }
    return langName;
  }

  protected buildIwsPreferredList() {
    this.services.UserPreference.userPreference.DefaultList = [];
    this.services.UserPreference.userPreference.preferredList = [];

    this.services.dataStore.getWatchList().forEach(element => {
      if (element.isCustom) {
        let mwItem = [];

        this.services.dataStore.watchListMap.get(element.text).forEach(element => {
        const stock = this.services.dataStore.getProductForMarketWatch(element.product); //added by shanmugapriya
	element.product = stock;
          //console.log("element.product",element.product);
          if(element.product == "FUTSTK" || element.product == "OPTSTK"){
            element.product = "FUTOPT";
          }else{
            element.product = element.product;
          }
          let item = {};
          item["Symbol"] = element.symbol;
          item["Exch"] = element.exch;
          item["Product"] = element.product;
          item["Board"] = element.board;
          mwItem.push(item);
        });
        this.services.UserPreference.userPreference[element.text] = mwItem;
        this.services.UserPreference.userPreference.preferredList.push(element.text);
        if (element.isDefault) {
          this.services.UserPreference.userPreference.DefaultList.push(element.text);
        }
      }
    });
  }

}
